// Short flavor-text descriptions shown on the buildings list row. Indexed by
// BuildingType (see types/castle.ts). Written for new players — plain words,
// what the building does and when you'd want to upgrade it.
export const BuildingDescriptions: Record<number, string> = {
  0: "Главное здание. Каждый его уровень открывает новые здания.",
  1: "Добывает золото. Чем выше уровень — тем быстрее.",
  2: "Добывает дерево. Чем выше уровень — тем быстрее.",
  3: "Добывает камень. Чем выше уровень — тем быстрее.",
  4: "Добывает ману для магов и заклинаний.",
  5: "Увеличивает, сколько ресурсов можно хранить.",
  6: "Готовит пехоту — твоих ближников.",
  7: "Готовит лучников — стреляют издалека.",
  8: "Готовит магов — бьют по броне.",
  9: "Готовит особого воина стихии (феникса, русалку, грифона или титана).",
  10: "Лечит твоих раненых воинов после боя.",
  11: "Каждый уровень даёт одну отправку войск одновременно.",
  12: "Изучает улучшения для армии и экономики.",
  13: "Здесь нанимаешь и прокачиваешь героев.",
  14: "Ускоряет постройку всех зданий.",
  15: "Возвращает в строй убитых защитников.",
};
